<script setup>

</script>

<template>
  <p>Dashboard</p>
</template>